import { Injectable } from "@angular/core";

/** This is service is a thin wrapper around window.loaction.reload
 * for testing and future refactoring ease
 */
@Injectable()
export class LocationManagerService {
  constructor() {}
  reload(): void {
    window.location.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/locationManager.service.ts